import { defineStore } from 'pinia';
import { useListCoils, type ListCoilResponse } from '../api/listCoils';
import { useCoilStore } from 'shared/coils/stores/coilStore';
import { useRefreshStore } from '@/common/composables/refreshStore';

export const useRefreshCoilStore = defineStore('refresh-coils', () => {
  const listCoils = useListCoils();
  const store = useCoilStore();

  const { initialize, refresh } = useRefreshStore<ListCoilResponse>({
    fetchFromServer() {
      return listCoils.execute();
    },
    mergeToStore(response) {
      store.clear();
      store.merge(response.page.coils);
    },
  });

  return {
    initialize,
    refresh,
  };
});
